import React, { useState, useEffect } from "react";
import logoHorizontalBlanco from "../../../../static/img/logo_horizontal.png";
import "./styles.css";
import verPassword from "../../../../static/img/TogglePassword.svg";
import { useNavigate } from "react-router-dom";
import { login } from "../../../../services/authApi";
import axios from "axios";
import LoadingScreen from "../../../../static/assets/loadingScreen/loadingScreen";
import CuadroTexto from "../../../../static/assets/cuadroTexto/cuadroTexto";

export const Intro = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const navigate = useNavigate();

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrorMessage("");
    try {
      const response = await login({ email, password });
      if (response.data) {
        const { csrfToken, sessionId, usuario } = response.data;

        localStorage.setItem("sessionId", sessionId);
        localStorage.setItem("csrfToken", csrfToken);

        axios.defaults.headers.common["X-CSRFToken"] = csrfToken;
        axios.defaults.headers.common["Authorization"] = `Session ${sessionId}`;

        navigate(usuario.area_personal_url);
      }
    } catch (err) {
      setErrorMessage(
        err.response?.data?.error || "Error al iniciar sesión. Verifica tus credenciales e inténtalo de nuevo."
      );
    } finally {
      setLoading(false);
    }
  };

  const handleRegister = (e) => {
    e.preventDefault();
    navigate("/registro");
  };

  const handleRememberMeChange = () => {
    setRememberMe(!rememberMe);
  };

  const handleForgotPassword = () => {
    navigate("/recuperar");
  };

  useEffect(() => {
    document.body.classList.add("no-footer-padding");

    return () => {
      document.body.classList.remove("no-footer-padding");
    };
  }, []);

  if (loading) {
    return <LoadingScreen />;
  }

  return (
    <div className="intro">
      {/* Mostrar mensaje de error si existe */}
      {errorMessage && (
        <CuadroTexto
          message={errorMessage}
          onAccept={() => setErrorMessage("")}
          showCancel={false}
        />
      )}
      <img
        className="logo-horizontal"
        alt="Logo horizontal"
        src={logoHorizontalBlanco}
      />

      <p className="div">The work is behind the scenes</p>

      <form className="login-form" onSubmit={handleSubmit}>
        {/* Campo de Email */}
        <div className="email">
          <input
            type="text"
            value={email}
            onChange={handleEmailChange}
            placeholder="Usuario"
            className="input-field"
            required
          />
        </div>

        {/* Campo de Contraseña */}
        <div className="password-container">
          <input
            type={showPassword ? "text" : "password"}
            value={password}
            onChange={handlePasswordChange}
            placeholder="Contraseña"
            className="input-field"
            required
          />
          <img
            className="verPassword"
            onClick={togglePasswordVisibility}
            alt="Toggle visibility"
            src={verPassword}
          />
        </div>

        {/* Checkbox Recordarme */}
        <div className="remember-me">
          <input
            type="checkbox"
            id="rememberMe"
            checked={rememberMe}
            onChange={handleRememberMeChange}
            className="checkbox"
          />
          <label htmlFor="rememberMe" className="checkbox-label">
            Recordarme
          </label>
        </div>

        {/* Botón de Iniciar Sesión */}
        <button type="submit" className="iniciar-sesion">
          Iniciar sesión
        </button>

        {/* Botón de Registrarse */}
        <div className="register-link" onClick={handleRegister}>
          Primera vez? Registrate
        </div>

        {/* Enlace de Recuperar Contraseña */}
        <div className="forgot-password-link" onClick={handleForgotPassword}>
          ¿Olvidaste tu contraseña?
        </div>

      </form>
    </div>
  );
};

export default Intro;
